import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getFusionGDBData,
  getFusionGDBGenesNumber,
} from "../../../../state/selectors/FusionGdb.selectors";

const GeneFusionGdbCard = ({ card, fusionGDBGenesNumber, fusionGDBData }) => {
  const isDisabled = !Object.keys(fusionGDBData || {}).length;

  return (
    <CardWrapper {...card} card={card} isDisabled={isDisabled}>
      {fusionGDBGenesNumber && (
        <div>
          <span>Fusion Genes:</span>{" "}
          <span className="tw-font-bold" data-testid="fusion-gdb-genes-number">
            {fusionGDBGenesNumber}
          </span>
        </div>
      )}
    </CardWrapper>
  );
};

GeneFusionGdbCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  fusionGDBGenesNumber: PropTypes.number,
  fusionGDBData: PropTypes.shape({}),
};

GeneFusionGdbCard.defaultProps = {
  fusionGDBGenesNumber: null,
  fusionGDBData: {},
};

const mapStateToProps = (state) => ({
  fusionGDBGenesNumber: getFusionGDBGenesNumber(state),
  fusionGDBData: getFusionGDBData(state),
});

export default connect(mapStateToProps, {})(GeneFusionGdbCard);
